/**
 * Custom FAQ Section script
 * Handles switching between FAQ answers based on sidebar selection.
 */

class FaqTileCustom {
  constructor(section) {
    this.section = section;
    this.sidebarItems = this.section.querySelectorAll('.faq-tile-custom__sidebar-item');
    this.contentItems = this.section.querySelectorAll('.faq-tile-custom__content-inner');
    
    this.init();
  }

  init() {
    this.sidebarItems.forEach(item => {
      item.addEventListener('click', () => {
        const id = item.dataset.faqId;
        this.switchFaq(id);
      });
    });

    // Support for Shopify Theme Editor
    document.addEventListener('shopify:block:select', (event) => {
      if (this.section.contains(event.target)) {
        const id = event.detail.blockId;
        this.switchFaq(id);
      }
    });
  }

  switchFaq(id) {
    if (!id) return;

    // Update Sidebar
    this.sidebarItems.forEach(item => {
      if (item.dataset.faqId === id) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });

    // Update Content
    this.contentItems.forEach(content => {
      if (content.dataset.faqContentId === id) {
        content.classList.add('is-active');
      } else {
        content.classList.remove('is-active');
      }
    });
  }
}

// Initialize for each section on the page
function initFaqCustomSections() {
  const sections = document.querySelectorAll('.section-faq-tile-custom');
  sections.forEach(section => {
    if (!section.dataset.faqInitialized) {
      new FaqTileCustom(section);
      section.dataset.faqInitialized = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', initFaqCustomSections);

// Re-initialize when a section is added/updated in the theme editor
document.addEventListener('shopify:section:load', initFaqCustomSections);
